module.exports = __webpack_public_path__ + "static/media/game.2ed199ac.svg";